import { render, staticRenderFns } from "./JSONTreeview.vue?vue&type=template&id=2258c98c"
import script from "./JSONTreeview.vue?vue&type=script&lang=js"
export * from "./JSONTreeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports